module.exports = __webpack_public_path__ + "img/emoji.b388ebd8.png";